import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { Link } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const AuthLayout = ({ title, children }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Box
        backgroundColor={colors.primary[400]}
        color={colors.primary[100]}
        width="600px"
        borderRadius="5px"
        textAlign="center"
        p="20px"
      >
        <Box textAlign="start">
          <Link to="/" style={{ textDecoration: "none", color: "#fff" }}>
            <IconButton sx={{ marginRight: "5px" }}>
              <ArrowBackIcon />
            </IconButton>
            Back to home
          </Link>
        </Box>
        <Typography variant="h1" my={3} color="text.primary">
          {title}
        </Typography>
        {children}
      </Box>
    </Box>
  );
};

export default AuthLayout;
